<template>
    <div class="sustainable-component work-organisation-result">
        <div class="container-fluid p-0 mt-3">
            <div class="row">
                <div class="col-12 col-md-6">
                    <v-select data-testid="work-description-position-select" bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" :items="internalModel.JobPositions" v-model="selectedPosition" item-title="Name" item-value="JobPositionId"></v-select>
                </div>
                <div class="col-12 col-md-6">
                    <a data-testid="work-description-open-selected" href="javascript:void(0)" @click="printWorkDescription">Visa befattningens arbetsbeskrivning</a><br />
                    <a data-testid="work-description-open-all" href="javascript:void(0)" @click="printAllWorkDescription">Visa alla arbetsbeskrivningar</a>
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>


<script>

    import CommonSpinner from '../../common/common-spinner.vue'

    export default {

        name: 'work-organisation-result',
        emits: ['positionSelected', 'position-selected'],
        props: {
            model: Object,
            selectedJobPosition: [String, Number],
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner
        },
        methods: {
            normalizeJobPositionId(value) {
                if (value === null || value === undefined || value === '') {
                    return null;
                }

                var asNumber = Number(value);
                return Number.isNaN(asNumber) ? value : asNumber;
            },
            syncJobPositionsFromModel() {
                this.internalModel = this.model;
            },
            setSelectedJobPositionFromProp(newVal) {
                var id = this.normalizeJobPositionId(newVal);
                if (id === null) {
                    return;
                }

                if (this.selectedPosition !== id) {
                    this.selectedPosition = id;
                }
            },
            ensureInitialSelection() {
                this.syncJobPositionsFromModel();
                this.setSelectedJobPositionFromProp(this.selectedJobPosition);

                if ((this.selectedPosition === null || this.selectedPosition === undefined || this.selectedPosition === '')
                    && this.internalModel.JobPositions.length > 0) {
                    this.selectedPosition = this.internalModel.JobPositions[0].JobPositionId;
                }
            },
            async printWorkDescription() {
                if (this.selectedPosition == null) {
                    alert("Välj en befattning");
                    return;
                }
                this.newWindow = window.open('/workorganisation/print?selectedWorkPositionId=' + this.selectedPosition , '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            async printAllWorkDescription() {
                this.newWindow = window.open('/workorganisation/print', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },

        data() {
            return {
                internalModel:{
                    JobPositions: [],
                    JobTaskSuggestions: [],
                },
                jobPositionTasks: [],
                jobPositionBlocks: [],
                jobPositionName: '',
                jobBlockName: '',
                jobBlockNumber: -1,
                selectedPosition: null,
                enableRegulation: false,
                newWindow: {},
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            selectedPosition: function (newVal) {
                if (newVal === null || newVal === undefined || newVal === '') {
                    return;
                }
                this.$emit('positionSelected', newVal)
                this.$emit('position-selected', newVal)
            },
            selectedJobPosition: function (newVal) {
                this.setSelectedJobPositionFromProp(newVal);
            },
            'model.JobPositions': function (newList, oldList) {
                if (newList !== oldList) {
                    this.syncJobPositionsFromModel();
                    this.setSelectedJobPositionFromProp(this.selectedJobPosition);
                }
            },
        },
        created() {
            this.ensureInitialSelection();
        },
        mounted() {
            this.ensureInitialSelection();
        },
        setup() {
            return {  }
        }
    }
</script>
